import Grid from '@mui/material/Grid'
import { getDisplayName } from 'helpers/global.helper/global.helper'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'ui/atoms'
import NewButton from 'ui/atoms/NewButton/NewButton'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import SystemMessageBanner from 'ui/components/SystemMessageBanner/SystemMessageBanner'
import View from 'ui/components/View/View'
import CreateSandboxPopover from './components/CreateSandboxPopover/CreateSandboxPopover'
import SandboxTable from './components/SandboxTable/SandboxTable'

const widgetConstants = {
  SANDBOX_TABLE: `sandboxTable`,
}

export default function SandboxView(): ReactElement {
  const { t } = useTranslation()

  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const { activeSystem } = useAuth()
  const system = activeSystem ? getDisplayName(activeSystem) : ``

  return (
    <View
      header={
        <ModuleHeader
          infoHeader={
            <Grid container direction="column">
              {t(`Sandbox`)}
            </Grid>
          }
        >
          <>
            <Grid container sx={{ width: '100%' }} justifyContent="flex-end">
              <Grid
                size={{
                  xs: 6,
                  md: 5,
                  lg: 3,
                  xl: 2,
                }}
              >
                <NewButton
                  variant="add"
                  label={t(`Create new project`)}
                  onClick={() => {
                    setCreateDialogOpen(true)
                  }}
                />
              </Grid>
            </Grid>
          </>
        </ModuleHeader>
      }
    >
      <SystemMessageBanner module="sandbox" />
      <Grid size={12}>
        <Card tourId={widgetConstants.SANDBOX_TABLE} title={t(`My sandbox projects for: {{system}}`, { system })}>
          <SandboxTable />
        </Card>
      </Grid>
      <CreateSandboxPopover open={createDialogOpen} closePopover={() => setCreateDialogOpen(false)} />
    </View>
  )
}
